module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/rowhouse-37365a2bcb32fe1dd389a4d5dadec7d7.png";